export function getVersionComponentTextContainerStyle(theme, marginBottom) {
    return {
        root: {
            background: theme.customSemanticColors.textboxTranslucent,
            borderRadius: "4px",
            marginBottom: marginBottom,
            width: "100%",
        },
    };
}
